import { MeshData } from "../MeshManager";
import { ShaderManager } from "../ShaderManager";
import { TextureManager } from "../TextureManager";
import { RenderObject, RenderObjectConstructorArgs, RenderObjectExportValues } from "./RenderObject";
import { Material, ObjectType } from "./types";

export type MeshArgs = {
  fileName: string;
  objData: MeshData;
  material?: Material;
} & RenderObjectConstructorArgs;

export class Mesh extends RenderObject {
  public fileName: string;

  constructor(args: MeshArgs) {
    super(args);
    this.fileName = args.fileName;
    this.type = ObjectType.MESH;

    if (args.material) {
      this.material = args.material;
    }

    this.model.vertices = [...args.objData.vertices];
    this.model.normals = [...args.objData.normals];
    this.model.uvs = [...args.objData.uvs];
  }

  async setup(gl: WebGL2RenderingContext, shaderManager: ShaderManager, textureManager: TextureManager) {
    if (this.material) {
      this.material.diffuseTexture = textureManager.getTexture(this.material.diffuseTexture?.name);
      this.material.normalTexture = textureManager.getTexture(this.material.normalTexture?.name, "normal");
    }

    this.calculateCentroid(this.model.vertices);
    this.initShader(gl, shaderManager);
    this.initBuffers(gl);
  }

  export(): RenderObjectExportValues {
    const exportValues = super.export();
    exportValues.fileName = this.fileName;
    return exportValues;
  }

  clone(name: string): Mesh {
    return new Mesh({
      fileName: this.fileName,
      name,
      position: this.model.position,
      scale: this.model.scale,
      rotation: this.model.rotation,
      diffuseTextureFile: this.material?.diffuseTexture?.name,
      normalTextureFile: this.material?.normalTexture?.name,
      material: this.material,
      objData: { vertices: [...this.model.vertices], normals: [...this.model.normals], uvs: [...this.model.uvs] }
    });
  }
}
